import { createAction, createAsyncAction } from 'typesafe-actions';
import { CachedFaqItems } from 'src/models/FaqItem';

export const resetUserGuide = createAction('userGuide/RESET')();
export const getFaqItems = createAsyncAction(
  'userGuide/GET_FAQ_ITEMS_REQUEST',
  'userGuide/GET_FAQ_ITEMS_SUCCESS',
  'userGuide/GET_FAQ_ITEMS_FAILURE'
)<string,CachedFaqItems, Error>();